import { IApplicationState, TBoardId, TListId } from '../../../../../../../../../types/types';
import { createDeepEqualSelector } from '../../../../../../../helpers/memoizeHelper';
import { IList } from '../../../../../../../../../store/model/list/types';
import { ISelectOptionsArray } from 'kui';
import { getPushNotificationListChangeToIds } from '../../../../../../../../../store/model/selectors/getPushNotificationListChangeToIds';
import { getBoardListsByStatus } from 'app/store/model/selectors/getBoardListsByStatus';

type TgetListChangeToSelectOptions = (
    state: IApplicationState,
    boardId: TBoardId,
) => ISelectOptionsArray;

export const getListChangeToSelectOptionsSelector = (): TgetListChangeToSelectOptions => createDeepEqualSelector(
    getBoardListsByStatus,
    getPushNotificationListChangeToIds,
    (lists: IList[], changeToListIds: TListId[]) => {
        return lists.map(list => {
            return {
                active: changeToListIds.includes(list.id),
                value: list.id,
                text: list.name,
            };
        });
    }
)
